module.exports = __webpack_public_path__ + "img/dk.svg";